<script setup lang="ts">
import { reactive } from "vue";
const form = reactive({ type: "PURCHASE", title: "", amount: null as number | null, occurredOn: "", product: "", remark: "" });
</script>

<template>
  <div class="notice">当前只交付表单与数据模型；审批人和分摊规则配置完成前，提交按钮保持关闭，避免产生无审批链数据。</div>
  <div class="panel"><h2>费用申请</h2><el-form :model="form" label-position="top"><div class="form-grid">
    <el-form-item label="费用类型"><el-select v-model="form.type"><el-option label="采购费用" value="PURCHASE"/><el-option label="市场费用" value="MARKETING"/><el-option label="日常费用" value="GENERAL"/></el-select></el-form-item>
    <el-form-item label="发生日期"><el-date-picker v-model="form.occurredOn" type="date" value-format="YYYY-MM-DD"/></el-form-item>
    <el-form-item class="full" label="标题"><el-input v-model="form.title"/></el-form-item>
    <el-form-item label="金额"><el-input-number v-model="form.amount" :precision="2" :min="0"/></el-form-item>
    <el-form-item label="归集商品"><el-input v-model="form.product" placeholder="待商品主数据接入" disabled/></el-form-item>
    <el-form-item class="full" label="说明"><el-input v-model="form.remark" type="textarea" :rows="4"/></el-form-item>
  </div><el-button type="primary" disabled>提交审批</el-button></el-form></div>
</template>
